import styled from 'styled-components';

export const ProductsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 24px;
  max-width: 840px;
  margin: 0 auto;
`;

export const ProductCard = styled.div`
  position: relative;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 34px;
  box-shadow: var(--shadow-sm);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  overflow: hidden;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #34d399, #10b981);
  }

  &:hover {
    transform: translateY(-4px);
    box-shadow: var(--shadow-lg);
    border-color: #d7dde6;
  }
`;

export const ProductTop = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 18px;
`;

export const ProductMark = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 13px;
  background: var(--bg-dark);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.35rem;
`;

export const ProductName = styled.h3`
  font-size: 1.45rem;
  font-weight: 800;
  color: var(--ink);
`;

export const ProductP = styled.p`
  font-size: 1.02rem;
  color: var(--text);
  line-height: 1.65;
  margin-bottom: 18px;
`;

export const ProductOwnership = styled.span`
  display: inline-flex;
  align-items: center;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--accent-strong);
  background: var(--accent-soft);
  padding: 6px 12px;
  border-radius: var(--radius-pill);
  margin-bottom: 26px;
`;

export const ProductLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: auto;
  border-radius: var(--radius-pill);
  background: var(--ink);
  padding: 12px 22px;
  color: #fff;
  font-size: 0.98rem;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.18s ease, transform 0.18s ease;

  &:hover {
    background: var(--accent-strong);
    transform: translateY(-1px);
  }
`;
